import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-proto';
import { Resource } from '@opentelemetry/resources';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';

export function setupTracer() {
  // Confgiuration for Sumo Logic Collector
  const sumoLogicCollectorConfig = {
    url: 'https://endpoint4.collection.sumologic.com/receiver/v1/trace/ZaVnC4dhaV0HmYKTcdo8bD0_LDDRpgSIHICrwtlZZMR8mgKnRVGdwL7NI_8wVivEUehYU6HpNpiFZnTwQphy3OZE7XBcNTGM4fpXPN9mdM2zTxiHxekmlg==',
    concurrencyLimit: 10,
  };
  // Confgiuration for Signoz Collector
  const signozCollectorConfig = {
    url: 'https://otel-poc.conviva.com/v1/traces',
    headers: {
      'Content-Security-Policy': 'upgrade-insecure-requests',
      Authorization:
        'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjAwMDEifQ.eyJzdWIiOiJzbGluZy1vdGVsLXBvYyIsImlhdCI6MTcwMDA4NjE0MiwiZXhwIjoxNzA1Mzg1MzQyfQ.sygQIn0k6ZwdvBNozIdORGqBcYA9ZUnelbVbq6LY_Fo',
    },
  };

  const resource = Resource.default().merge(
    new Resource({
      [SemanticResourceAttributes.SERVICE_NAME]: 'instant-filter-client',
    }),
  );

  // To start a trace, you first need to initialize the Tracer provider.
  const provider = new WebTracerProvider({
    resource,
  });

  const collectorTraceExporter = new OTLPTraceExporter(sumoLogicCollectorConfig);
  const collectorSignozTraceExporter = new OTLPTraceExporter(signozCollectorConfig);

  // Below configuration is based upon the BatchSpanProcessor documentation
  const collectorProcessor = new BatchSpanProcessor(collectorTraceExporter, {
    // The maximum queue size. After the size is reached spans are dropped.
    maxQueueSize: 100,
    // The maximum batch size of every export. It must be smaller or equal to maxQueueSize.
    maxExportBatchSize: 10,
    // The interval between two consecutive exports
    scheduledDelayMillis: 500,
    // How long the export can run before it is cancelled
    exportTimeoutMillis: 30000,
  });
  const collectorSignozProcessor = new BatchSpanProcessor(collectorSignozTraceExporter, {
    // The maximum queue size. After the size is reached spans are dropped.
    maxQueueSize: 100,
    // The maximum batch size of every export. It must be smaller or equal to maxQueueSize.
    maxExportBatchSize: 10,
    // The interval between two consecutive exports
    scheduledDelayMillis: 500,
    // How long the export can run before it is cancelled
    exportTimeoutMillis: 30000,
  });

  // Adding the processor the tracer provider
  provider.addSpanProcessor(collectorProcessor);
  provider.addSpanProcessor(collectorSignozProcessor);

  // NOTE: The default OpenTelemetry tracer provider does not record any tracing information.
  //       Registering a working tracer provider allows the API methods to record traces.
  provider.register();
}
